/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "components/CounterCards/DefaultCounterCard";

function Counters() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={process.env.REACT_APP_TRAIL_COUNT}
              title="Unique Trails"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={process.env.REACT_APP_TRAIL_LENGTH}
              title="Total Miles"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={process.env.REACT_APP_PARK_COUNT}
              title="Parks"
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
